/* eslint-disable react/prop-types */ // TODO: add props
import cx from 'classnames';
import { IndicatorCell, INDICATOR_TYPES } from '../../../../../components';
import { RowExpansionArrow } from '../../../components/Icons';
import { DragAndDropQuestion } from 'edrolo/domains/exams/components/Question/components/DragAndDropQuestion';
import {
  correctableQuestionPropTypes,
  CorrectableQuestionReview,
} from './CorrectableQuestionReview';
import {
  name,
  selfReflection,
} from '../../../components/TableColumns/TableColumns';

import style from './styles.scss';

const DragAndDropQuestionReview = ({
  question,
  getStudentCourseProgressUrl,
  ...restProps
}) => {
  const expander = {
    id: 'expander',
    Header: '',
    style: { width: '3%' },
    Cell: ({ row }) =>
      row.original.getIn(['response', 'field_responses', 0]) ? (
        <div
          className={cx(style.expanderWidgetContainer, style.fullWidthCell)}
          {...row.getToggleRowExpandedProps()}
        >
          {row.isExpanded ? (
            <RowExpansionArrow expanded />
          ) : (
            <RowExpansionArrow />
          )}
        </div>
      ) : null,
  };

  const studentResponseColumn = {
    id: 'studentResponse',
    Header: 'Student Response',
    style: { width: '50%' },
    accessor: (row) => {
      return {
        response: row.get('response'),
      };
    },

    Cell: ({ cell, row }) => {
      const { response } = cell.value;

      return response && response.get('field_responses').size > 0 ? (
        <div {...row.getToggleRowExpandedProps()}>
          {row.isExpanded ? (
            <div className={cx(style.fullWidthCell, style.responseWrapper)}>
              <DragAndDropQuestion
                question={question}
                response={response}
                isQuestionReview
              />
            </div>
          ) : (
            <div className={style.responseWrapper}>
              <span>View student response</span>
            </div>
          )}
        </div>
      ) : (
        <IndicatorCell
          value={'Not answered'}
          indicatorType={INDICATOR_TYPES.NEUTRAL}
        />
      );
    },

    sortType: (rowA, rowB) => {
      let isAnsweredA = null;
      let isAnsweredB = null;
      const responseA = rowA.original.get('response');
      const responseB = rowB.original.get('response');

      if (responseA && responseA.get('field_responses').size > 0) {
        isAnsweredA = true;
      }
      if (responseB && responseB.get('field_responses').size > 0) {
        isAnsweredB = true;
      }

      const isCorrectSortOrder = [true, null];

      if (
        isCorrectSortOrder.indexOf(isAnsweredA) >
        isCorrectSortOrder.indexOf(isAnsweredB)
      ) {
        return 1;
      }

      return -1;
    },
  };

  const answeredCorrectly = {
    id: 'answeredCorrectly',
    Header: 'Answered correctly',
    accessor: (row) => {
      return row.getIn(['response', 'field_responses', 0])
        ? `${row.get('correct') ? 'Yes' : 'No'}`
        : 'Not answered ';
    },

    Cell: (cell) =>
      cell.row.original.getIn(['response', 'field_responses', 0]) ? (
        <IndicatorCell
          value={cell.value}
          indicatorType={
            cell.row.original.get('correct')
              ? INDICATOR_TYPES.POSITIVE
              : INDICATOR_TYPES.NEGATIVE
          }
        />
      ) : (
        <IndicatorCell
          value={cell.value}
          indicatorType={INDICATOR_TYPES.NEUTRAL}
        />
      ),

    sortType: (rowA, rowB) => {
      let isCorrectA = null;
      let isCorrectB = null;
      const responseA = rowA.original.get('response');
      const responseB = rowB.original.get('response');

      if (responseA && responseA.get('field_responses').size > 0) {
        isCorrectA = rowA.original.get('correct');
      }
      if (responseB && responseB.get('field_responses').size > 0) {
        isCorrectB = rowB.original.get('correct');
      }

      const isCorrectSortOrder = [true, false, null];

      if (
        isCorrectSortOrder.indexOf(isCorrectA) >
        isCorrectSortOrder.indexOf(isCorrectB)
      ) {
        return 1;
      }

      return -1;
    },
  };

  return (
    <CorrectableQuestionReview
      question={question}
      nameColumn={{
        ...name(getStudentCourseProgressUrl),
        style: { width: '16%' },
      }}
      studentResponseColumnSpec={studentResponseColumn}
      selfReflectionColumn={{ ...selfReflection, style: { width: '8.5%' } }}
      answeredCorrectlyColumn={{
        ...answeredCorrectly,
        style: { width: '8.5%' },
      }}
      expanderColumn={expander}
      checklist
      showChart
      showCorrectness
      {...restProps}
    />
  );
};

export default DragAndDropQuestionReview;

DragAndDropQuestionReview.propTypes = correctableQuestionPropTypes;
